import { render, staticRenderFns } from "./LinkedRiskEvidenceModal.vue?vue&type=template&id=c48c42a6&scoped=true"
import script from "./LinkedRiskEvidenceModal.vue?vue&type=script&lang=js"
export * from "./LinkedRiskEvidenceModal.vue?vue&type=script&lang=js"
import style0 from "./LinkedRiskEvidenceModal.vue?vue&type=style&index=0&id=c48c42a6&prod&scoped=true&lang=css"
import style1 from "./LinkedRiskEvidenceModal.vue?vue&type=style&index=1&id=c48c42a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48c42a6",
  null
  
)

export default component.exports